import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M4.13 12H4a2 2 0 1 0 1.8 1.11L7.86 10a2 2 0 0 0 .65-.07l1.55 1.55a2 2 0 1 0 3.72-.37L15.87 8H16a2 2 0 1 0-1.8-1.11L12.14 10a2 2 0 0 0-.65.07L9.93 8.52a2 2 0 1 0-3.72.37zM0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
      fill="currentColor"
    />
  </svg>
);
